import { useTranslation } from 'react-i18next';
import { Icon } from './Icon';

/**
 * #959 (owner): Help is a first-class control -- the same "? Help" in the same place on every
 * header bar, just before the account. The word hides on a narrow bar; the name stays.
 */
export function HelpLink() {
  const { t } = useTranslation();
  return (
    <a className="help-link" href="/help/" title={t('help.title')}>
      <Icon name="help" />
      <span className="help-link-label">{t('help.link')}</span>
    </a>
  );
}
